<div class="form-field"
     [class.form-field--invalid]="showError"
     [attr.data-testid]="resolvedTestId">
  @if (label()) {
    <label class="field-label body-md-bold"
           [class.label-invalid]="showError"
           [attr.for]="inputId() || null">
      {{ label() }}@if (required()) {<span class="field-label-required">*</span>}@if (optional()) {<span class="field-label-optional"> (optional)</span>}@if (labelSuffix()) {<span class="field-label-suffix"> {{ labelSuffix() }}</span>}
    </label>
  }

  <div class="field-control">
    <ng-content />
  </div>

  <div class="field-footer">
    @if (showError && errorText) {
      <app-input-error class="field-error"
                       [attr.data-testid]="resolvedTestId + '-error'">{{ errorText }}</app-input-error>
    } @else if (hint()) {
      <small class="field-hint body-sm-regular">{{ hint() }}</small>
    }
    @if (maxLength() !== null) {
      <app-character-count class="field-count"
                           [current]="controlLength"
                           [max]="maxLength()!" />
    }
    <span class="field-footer-slot">
      <ng-content select="[fieldFooter]" />
    </span>
  </div>
</div>
